/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const termsEditorCommon = {
	mainMenu: {
		open: "menu:main.open#label",
		search: {
			placeholder: "menu:main.search#placeholder"
		},
		sectionCreate: {
			title: "menu:main.sectionCreate#title",
			action: {
				label: "menu:main.sectionCreate.action#label",
				tooltip: "menu:main.sectionCreate.action#tooltip"
			},
			actionTrigger: {
				label: "menu:main.sectionCreate.actionTrigger#label",
				tooltip: "menu:main.sectionCreate.actionTrigger#tooltip"
			},
			directory: {
				label: "menu:main.sectionCreate.directory#label",
				tooltip: "menu:main.sectionCreate.directory#tooltip"
			},
			modelEntity: {
				label: "menu:main.sectionCreate.modelEntity#label",
				tooltip: "menu:main.sectionCreate.modelEntity#tooltip"
			},
			integration: {
				label: "menu:main.sectionCreate.integration#label",
				tooltip: "menu:main.sectionCreate.integration#tooltip"
			},
			widget: {
				label: "menu:main.sectionCreate.widget#label",
				tooltip: "menu:main.sectionCreate.widget#tooltip"
			},
			apiEndpoint: {
				label: "menu:main.sectionCreate.apiEndpoint#label",
				tooltip: "menu:main.sectionCreate.apiEndpoint#tooltip"
			},
			function: {
				label: "menu:main.sectionCreate.function#label",
				tooltip: "menu:main.sectionCreate.function#tooltip"
			},
			theme: {
				label: "menu:main.sectionCreate.theme#label",
				tooltip: "menu:main.sectionCreate.theme#tooltip"
			}
		},
		sectionManage: {
			title: "menu:main.sectionManage#title",
			appSettings: {
				label: "menu:main.sectionManage.appSettings#label",
				tooltip: "menu:main.sectionManage.appSettings#tooltip"
			},
			appConfig: {
				label: "menu:main.sectionManage.appConfig#label",
				tooltip: "menu:main.sectionManage.appConfig#tooltip"
			},
			translations: {
				label: "menu:main.sectionManage.translations#label",
				tooltip: "menu:main.sectionManage.translations#tooltip"
			},
			userManagement: {
				label: "menu:main.sectionManage.userManagement#label",
				tooltip: "menu:main.sectionManage.userManagement#tooltip"
			},
			deployments: {
				label: "menu:main.sectionManage.deployments#label",
				tooltip: "menu:main.sectionManage.deployments#tooltip"
			},
			exportSession: {
				label: "menu:main.sectionManage.exportSession#label",
				tooltip: "menu:main.sectionManage.exportSession#tooltip"
			},
			packages: {
				label: "menu:main.sectionManage.packages#label",
				tooltip: "menu:main.sectionManage.packages#tooltip"
			},
			externalLibs: {
				label: "menu:main.sectionManage.externalLibs#label",
				tooltip: "menu:main.sectionManage.externalLibs#tooltip"
			}
		},
		sectionMonitor: {
			title: "menu:main.sectionMonitor#title",
			diagnostics: {
				label: "menu:main.sectionMonitor.diagnostics#label",
				tooltip: "menu:main.sectionMonitor.diagnostics#tooltip"
			},
			errors: {
				label: "menu:main.sectionMonitor.errors#label",
				tooltip: "menu:main.sectionMonitor.errors#tooltip"
			},
			logs: {
				label: "menu:main.sectionMonitor.logs#label",
				tooltip: "menu:main.sectionMonitor.logs#tooltip"
			},
			stats: {
				label: "menu:main.sectionMonitor.stats#label",
				tooltip: "menu:main.sectionMonitor.stats#tooltip"
			}
		},
		sectionTools: {
			title: "menu:main.sectionTools#title",
			smartTemplates: {
				label: "menu:main.sectionTools.smartTemplates#label",
				tooltip: "menu:main.sectionTools.smartTemplates#tooltip"
			},
			importOpenApi: {
				label: "menu:main.sectionTools.importOpenApi#label",
				tooltip: "menu:main.sectionTools.importOpenApi#tooltip"
			},
			importBlueprint: {
				label: "menu:main.sectionTools.importBlueprint#label",
				tooltip: "menu:main.sectionTools.importBlueprint#tooltip"
			}
		},
		sectionSupport: {
			title: "menu:main.sectionSupport#title"
			// gettingStarted: {
			// 	label: "menu:main.sectionDocumentation.gettingStarted#label",
			// 	tooltip: "menu:main.sectionDocumentation.gettingStarted#tooltip"
			// },
			// userDocumentation: {
			// 	label: "menu:main.sectionDocumentation.userDocumentation#label",
			// 	tooltip: "menu:main.sectionDocumentation.userDocumentation#tooltip"
			// },
			// tutorials: {
			// 	label: "menu:main.sectionDocumentation.tutorials#label",
			// 	tooltip: "menu:main.sectionDocumentation.tutorials#tooltip"
			// },
			// referenceGuide: {
			// 	label: "menu:main.sectionDocumentation.referenceGuide#label",
			// 	tooltip: "menu:main.sectionDocumentation.referenceGuide#tooltip"
			// },
			// communityForum: {
			// 	label: "menu:main.sectionDocumentation.communityForum#label",
			// 	tooltip: "menu:main.sectionDocumentation.communityForum#tooltip"
			// }
		},
		sectionInspiration: {
			title: "menu:main.sectionInspiration#title",
			demoApps: {
				label: "menu:main.sectionInspiration.demoApps#label",
				tooltip: "menu:main.sectionInspiration.demoApps#tooltip"
			},
			useCaseGallery: {
				label: "menu:main.sectionInspiration.useCaseGallery#label",
				tooltip: "menu:main.sectionInspiration.useCaseGallery#tooltip"
			},
			playground: {
				label: "menu:main.sectionInspiration.playground#label",
				tooltip: "menu:main.sectionInspiration.playground#tooltip"
			}
		}
	},
	resourceList: {
		expandCollapse: {
			title: "resourceList:expandCollapse#title"
		},
		resourceActions: {
			title: "resourceList:resourceActions#title"
		},
		create: {
			title: "resourceList:create#title"
		},
		rename: {
			title: "resourceList:rename#title"
		},
		delete: {
			title: "resourceList:delete#title"
		}
	},
	resourceInfo: {
		savedTimeAgo: "resourceInfo:savedTimeAgo",
		savedAtBy: "resourceInfo:savedAtBy",
		saving: "resourceInfo:saving"
	},
	dialog: {
		confirmation: {
			buttonConfirm: "dialog:confirmation.buttonConfirm#label",
			buttonCancel: "dialog:confirmation.buttonCancel#label",
			buttonDelete: "dialog:confirmation.buttonDelete#label"
		},
		input: {
			title: "dialog:input.title",
			description: "dialog:input.description",
			buttonConfirm: "dialog:input.buttonConfirm#label",
			buttonCancel: "dialog:input.buttonCancel#label"
		},
		createDirectory: {
			title: "dialog:createDirectory.title",
			controls: {
				name: {
					label: "dialog:createDirectory.controls.name#label"
				},
				directory: {
					label: "dialog:createDirectory.controls.directory#label"
				}
			},
			buttonConfirm: "dialog:createDirectory.buttonConfirm#label",
			buttonCancel: "dialog:createDirectory.buttonCancel#label",
			messages: {
				pattern: "dialog:createDirectory.messages.pattern#message",
				duplicateIdentifier: "dialog:createDirectory.messages.duplicateIdentifier#message"
			}
		},
		resourceDelete: {
			title: "dialog:resourceDelete.title",
			message: {
				directory: "dialog:resourceDelete.directory#message",
				view: "dialog:resourceDelete.view#message",
				action: "dialog:resourceDelete.action#message",
				integration: "dialog:resourceDelete.integration#message",
				routes: "dialog:resourceDelete.routes#message",
				translations: "dialog:resourceDelete.translations#message",
				resource: "dialog:resourceDelete.resource#message"
			}
		},
		resourceRename: {
			title: "dialog:resourceRename.title",
			description: "dialog:resourceRename.description",
			actions: {
				confirm: "dialog:resourceRename.actions.confirm#label",
				cancel: "dialog:resourceRename.actions.cancel#label"
			},
			messages: {
				name: {
					duplicateIdentifier: "dialog:resourceRename.messages.name.duplicateIdentifier#message"
				}
			}
		},
		resourceDuplicate: {
			title: "dialog:resourceDuplicate.title",
			description: "dialog:resourceDuplicate.description",
			buttonConfirm: "dialog:resourceDuplicate.buttonConfirm#label",
			buttonCancel: "dialog:resourceDuplicate.buttonCancel#label"
		},
		closeModifiedView: {
			title: "dialog:closeModifiedView.title",
			message: "dialog:closeModifiedView.message",
			confirmButton: "dialog:closeModifiedView.confirmButton#label"
		},
		deployUnsaved: {
			title: "dialog:deployUnsaved.title",
			message: "dialog:deployUnsaved.message",
			confirmButton: "dialog:deployUnsaved.confirmButton#label"
		},
		deleteIntegrationConfig: {
			title: "dialog:deleteIntegrationConfig.title",
			message: "dialog:deleteIntegrationConfig.message",
			confirmButton: "dialog:deleteIntegrationConfig.confirmButton#label"
		}
	},
	toasts: {
		createDirectory: {
			error: {
				unknown: "toasts:createDirectory.error.unknown#message"
			}
		},
		resourceDelete: {
			directory: {
				success: "toasts:resourceDelete.directory.success#message",
				error: "toasts:resourceDelete.directory.error#message"
			},
			view: {
				success: "toasts:resourceDelete.view.success#message",
				error: "toasts:resourceDelete.view.error#message"
			},
			action: {
				success: "toasts:resourceDelete.action.success#message",
				error: "toasts:resourceDelete.action.error#message"
			},
			integration: {
				success: "toasts:resourceDelete.integration.success#message",
				error: "toasts:resourceDelete.integration.error#message"
			},
			routes: {
				success: "toasts:resourceDelete.routes.success#message",
				error: "toasts:resourceDelete.routes.error#message"
			},
			translations: {
				success: "toasts:resourceDelete.translations.success#message",
				error: "toasts:resourceDelete.translations.error#message"
			},
			resource: {
				success: "toasts:resourceDelete.resource.success#message",
				error: "toasts:resourceDelete.resource.error#message"
			}
		},
		resourceRename: {
			error: {
				unknown: "toasts:resourceRename.error.unknown#message",
				alreadyRenamed: "toasts:resourceRename.error.alreadyRenamed#message"
			}
		},
		resourceMove: {
			error: {
				unknown: "toasts:resourceMove.error.unknown#message",
				invalidTargetType: "toasts:resourceMove.error.invalidTargetType#message",
				targetNotFound: "toasts:resourceMove.error.targetNotFound#message"
			}
		}
	},
	dateTime: {
		unitsAgo: {
			year: {
				zero: "dateTime:unitsAgo.year#zero",
				one: "dateTime:unitsAgo.year#one",
				two: "dateTime:unitsAgo.year#two",
				more: "dateTime:unitsAgo.year#more"
			},
			month: {
				zero: "dateTime:unitsAgo.month#zero",
				one: "dateTime:unitsAgo.month#one",
				two: "dateTime:unitsAgo.month#two",
				more: "dateTime:unitsAgo.month#more"
			},
			week: {
				zero: "dateTime:unitsAgo.week#zero",
				one: "dateTime:unitsAgo.week#one",
				two: "dateTime:unitsAgo.week#two",
				more: "dateTime:unitsAgo.week#more"
			},
			day: {
				zero: "dateTime:unitsAgo.day#zero",
				one: "dateTime:unitsAgo.day#one",
				two: "dateTime:unitsAgo.day#two",
				more: "dateTime:unitsAgo.day#more"
			},
			hour: {
				zero: "dateTime:unitsAgo.hour#zero",
				one: "dateTime:unitsAgo.hour#one",
				two: "dateTime:unitsAgo.hour#two",
				more: "dateTime:unitsAgo.hour#more"
			},
			minute: {
				zero: "dateTime:unitsAgo.minute#zero",
				one: "dateTime:unitsAgo.minute#one",
				two: "dateTime:unitsAgo.minute#two",
				more: "dateTime:unitsAgo.minute#more"
			},
			second: {
				zero: "dateTime:unitsAgo.second#zero",
				one: "dateTime:unitsAgo.second#one",
				two: "dateTime:unitsAgo.second#two",
				more: "dateTime:unitsAgo.second#more"
			},
			now: "dateTime:unitsAgo.now"
		}
	},
	fields: {
		resource: {
			select: "fields:resource.select",
			notFound: "fields:resource.notFound",
			deleted: "fields:resource.deleted"
		},
		routeSelector: {
			select: "fields:routeSelector.select",
			notFound: "fields:routeSelector.notFound"
		}
	}
};
